/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TimeDetails {
    getFixupPrototypeFunction() { return TimeDetails.fixupPrototype; }

    static newInstance(model: Partial<TimeDetails>): TimeDetails {
        let obj = Object.assign(new TimeDetails(), model);
        TimeDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TimeDetails>): TimeDetails {
        if (!model) return null;
        return TimeDetails.newInstance(<TimeDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TimeDetails) {
        if (!obj) return;

        models.TimeDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TimeDetails): boolean {
        Object.setPrototypeOf(obj, TimeDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * The Template/Policy is scheduled at which second. Allowed values: 00-60
     */
    seconds: string;

    /**
     * The Template/Policy is scheduled at which minute. Allowed values: 00-60
     */
    minute: string;

    /**
     * The Template/Policy is scheduled at which hour. Allowed values: 01-23
     */
    hour: string;

}
